

export const apiUrl = process.env.REACT_APP_BACKEND_URL || `http://localhost:8080`;
export const frontendUrl = process.env.REACT_ISELECT_CALLBACK_URL || `http://localhost:3000`;
export const clientId = process.env.REACT_APP_CLIENT_ID;